import angularModule from 'Onboarding/angularModule/scripts/onboarding_module';
import { setupBrandNameProperties } from 'AppBranding';
import template from 'Onboarding/angularModule/views/onboarding.hybrid.forgot_password.html';
import cacheAngularTemplate from 'cacheAngularTemplate';

import logoSmall from 'images/onboarding/Logo-Small@2x.png';
import logoSmallQuantic from 'vectors/logos/quantic-logo-rebrand.svg';

const templateUrl = cacheAngularTemplate(angularModule, template);

angularModule.directive('onboardingHybridForgotPassword', [
    '$injector',
    function factory($injector) {
        const NavigationHelperMixin = $injector.get('Navigation.NavigationHelperMixin');
        const $window = $injector.get('$window');
        const ConfigFactory = $injector.get('ConfigFactory');

        return {
            restrict: 'E',
            templateUrl,
            scope: {},
            link(scope) {
                NavigationHelperMixin.onLink(scope);

                const config = ConfigFactory.getSync();
                setupBrandNameProperties($injector, scope, { config });

                const isQuantic = config.isQuantic();

                Object.defineProperty(scope, 'logoSmall', {
                    get() {
                        if (isQuantic) {
                            return logoSmallQuantic;
                        }
                        return logoSmall;
                    },
                });

                scope.logoWidth = isQuantic ? 150 : 50;
                scope.logoHeight = isQuantic ? 40 : 50;
            },
            controller: [
                '$scope',
                $scope => {
                    $scope.goBack = () => {
                        $window.history.back();
                    };

                    $scope.focus = () => {
                        $('.onboarding__form form input:first-of-type').bind('focusin focus', e => {
                            e.preventDefault();
                        });
                        $('.onboarding__form form input:first-of-type').focus();
                        $scope.recoverPasswordFormOptions = {
                            debounce: {
                                default: 0,
                                blur: 0,
                            },
                        };
                    };
                },
            ],
        };
    },
]);
